import { Skeleton } from "@pax/ui";

const CARDS = ["a", "b"];

export function GameShelfSkeleton() {
  return (
    <div aria-busy className="min-h-full">
      <div className="sticky top-0 z-20 bg-screen/70 py-3 backdrop-blur-xl">
        <div className="app-reading-width games-shelf flex items-center gap-3">
          <Skeleton className="h-9 flex-1 rounded-full" />
          <Skeleton className="size-9 shrink-0 rounded-full" />
        </div>
      </div>
      <div className="app-reading-width games-shelf grid gap-3 pt-6 pb-14 xl:grid-cols-2">
        {CARDS.map(card => (
          <Skeleton key={card} className="aspect-[16/10] w-full rounded-2xl" />
        ))}
      </div>
    </div>
  );
}
